export { DottedLineSeparator } from './dotted-line-separator';
export type { DottedLineSeparatorProps } from './dotted-line-separator';
